import { init } from '@inleads/event-logger';

const INLEADS_API_KEY = '70bfe7d2-3421-4706-aa3a-d2cb4597b2a1';

export const eventLogger = (): void => {
  init(INLEADS_API_KEY);
};
